export default {
    top_menu: [
        {name:'រឿងសំខាន់',    id:0},
        {name:'បង្ហាញអាជីវកម្ម', id:1},
        {name:'ចម្អិនអាហារ',  id:2},
        {name:'នយោបាយ',   id:3},
        {name:'គ្រឿងទេស',  id:4},
        {name:'សង្គម',   id:5},
        {name:'សុខភាព',   id:6},
    ],
    read_other: 'អាន​បន្ថែម',
    read_more:  'ព័ត៌មានលម្អិតបន្ថែម',
    not_found:  'រកមិនឃើញអ្វីទេ។',
    read_also:  'អានផងដែរ។',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». រក្សា​រ​សិទ្ធ​គ្រប់យ៉ាង.',
    subscribe: 'ជា​វ​ជា​ប្រចាំ​ទៅ​កាន់',
    thank_order: 'សូម​អរគុណ​សម្រាប់​ការ​បញ្ជា​ទិញ​របស់​អ្នក​',
    specialist_contact: 'អ្នកឯកទេសរបស់យើងនឹងទាក់ទងអ្នកក្នុងពេលឆាប់ៗនេះ រង់ចាំការហៅរបស់យើង។.',
    attention: 'ការបញ្ចុះតម្លៃពីដៃគូ:',
    hurry: 'ប្រញាប់ឡើង ការបញ្ចុះតម្លៃមានកំណត់! អ្នកមានអ្វីគ្រប់យ៉ាង <span id="time" class="time">30:00</span> នាទីដើម្បីជ្រើសរើសផលិតផលតែមួយគត់ទាំងនេះ:',
    hour_ago1: "ម៉ោងមុន។",
    hour_ago2: "ច្រើន​ម៉ោង​កន្លងទៅ",
    hour_ago3: "ច្រើន​ម៉ោង​កន្លងទៅ",
    new_publications: "ការបោះពុម្ពថ្មី។",
    read: "អាន",
    today_at: "ថ្ងៃនេះនៅ",
    author_names: ['Shiloh Nouvel','Daniel Edwards','ទម្លាក់ Kesting'],
    main_news: "ព័ត៌មានកំពូល",
    leave_already: "ចាកចេញហើយឬនៅ? រង់ចាំ យើង​បាន​ធ្វើ​បច្ចុប្បន្នភាព​ព័ត៌មាន​សម្រាប់​អ្នក។",
    already_shared: "ចែករំលែករួចហើយ"
}